import { render, staticRenderFns } from "./Classroom_new_text_detial.vue?vue&type=template&id=054b82cc&scoped=true"
import script from "./Classroom_new_text_detial.vue?vue&type=script&lang=js"
export * from "./Classroom_new_text_detial.vue?vue&type=script&lang=js"
import style0 from "./Classroom_new_text_detial.vue?vue&type=style&index=0&id=054b82cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054b82cc",
  null
  
)

export default component.exports